var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesignIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 71.5,
    height: 68.614,
    viewBox: "0 0 71.5 68.614",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1623",
    "data-name": "Rectangle 1623",
    width: 71.5,
    height: 68.614,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "design-icon",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60282",
    "data-name": "Path 60282",
    d: "M23.439,26.939,8.292,15.3a1.458,1.458,0,0,1-.365-.407L.22,2.281A1.5,1.5,0,0,1,1.929.062L16.1,4.258a1.5,1.5,0,0,1,.488.251L31.732,16.145,29.9,18.524,14.979,7.058,4.818,4.046l5.527,9.046L25.265,24.56Z",
    transform: "translate(0 0.001)",
    fill: "#ec431f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1617",
    "data-name": "Rectangle 1617",
    width: 10.611,
    height: 3.001,
    transform: "translate(8.016 13.197) rotate(-52.438)",
    fill: "#ec431f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60283",
    "data-name": "Path 60283",
    d: "M35.708,35.9a4.5,4.5,0,0,1-3.327-.89l-16.131-12.4,1.826-2.378L34.211,32.629a1.5,1.5,0,0,0,2.1-.276L39.121,28.7a1.5,1.5,0,0,0-.273-2.1L22.714,14.2l1.829-2.381L40.675,24.213a4.505,4.505,0,0,1,.828,6.313l-2.808,3.656A4.5,4.5,0,0,1,35.708,35.9",
    transform: "translate(29.063 21.138)",
    fill: "#ec431f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1618",
    "data-name": "Rectangle 1618",
    width: 10.611,
    height: 3.001,
    transform: "matrix(0.61, -0.793, 0.793, 0.61, 56.818, 50.695)",
    fill: "#ec431f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60284",
    "data-name": "Path 60284",
    d: "M7.647,30.063,5.269,28.237,7.19,25.73c.206-.265.36-.94-.669-3.695-1.249-3.357-.683-8.153,1.266-10.691l2.585-3.366,2.381,1.829-2.588,3.366c-1.191,1.55-1.8,5.22-.831,7.813,1.093,2.933,1.483,4.949.237,6.572Z",
    transform: "translate(9.423 14.271)",
    fill: "#051631"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60285",
    "data-name": "Path 60285",
    d: "M13.15,35.8,10.772,33.97l1.291-1.681a7.423,7.423,0,0,1,4.782-2.713,7.513,7.513,0,0,0,5.05-3.115L33.531,11.314l2.381,1.829L24.273,28.287a10.366,10.366,0,0,1-6.74,4.21,4.571,4.571,0,0,0-3.09,1.617Z",
    transform: "translate(19.265 20.235)",
    fill: "#051631"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60286",
    "data-name": "Path 60286",
    d: "M23.6,43.733,1.023,26.389l9.586-12.478L33.182,31.258ZM5.231,25.837,23.046,39.525l5.928-7.718L11.162,18.119Z",
    transform: "translate(1.83 24.88)",
    fill: "#051631"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1619",
    "data-name": "Rectangle 1619",
    width: 3.002,
    height: 4.245,
    transform: "translate(11.287 49.722) rotate(-52.475)",
    fill: "#051631"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1620",
    "data-name": "Rectangle 1620",
    width: 4.244,
    height: 3.001,
    transform: "translate(36.164 20.105) rotate(-52.438)",
    fill: "#051631"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1621",
    "data-name": "Rectangle 1621",
    width: 4.244,
    height: 3.001,
    transform: "translate(41.212 23.984) rotate(-52.438)",
    fill: "#051631"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1622",
    "data-name": "Rectangle 1622",
    width: 4.244,
    height: 3.001,
    transform: "translate(46.261 27.864) rotate(-52.438)",
    fill: "#051631"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60287",
    "data-name": "Path 60287",
    d: "M41.15,25.417l-2.379-1.829a2.332,2.332,0,0,0,.215-2.42,3.849,3.849,0,0,0-3.106-2.22l-1.829-.162.521-1.757a1.958,1.958,0,0,0-.714-1.308,2.578,2.578,0,0,0-2.479-.705l-2.359.68.468-2.409a1.625,1.625,0,0,0-.661-1.377,2.879,2.879,0,0,0-2.493-.775l-1.681.494-.229-1.74A2.964,2.964,0,0,0,22.217,7.56a2.667,2.667,0,0,0-2.945,1.048L10.221,20.387,7.843,18.558,16.894,6.779A5.65,5.65,0,0,1,23,4.66,6.089,6.089,0,0,1,27,8.073a6.159,6.159,0,0,1,3.842,1.617,5.079,5.079,0,0,1,1.478,2.239,5.693,5.693,0,0,1,3.709,1.72,5.239,5.239,0,0,1,1.461,2.571,6.85,6.85,0,0,1,4.241,3.739,5.255,5.255,0,0,1-.586,5.457",
    transform: "translate(14.026 7.961)",
    fill: "#051631"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignIcon);
export default __webpack_public_path__ + "static/media/design-icon.53c92fa4de3b99d0de500aad81896207.svg";
export { ForwardRef as ReactComponent };